import type { RouteRecordRaw } from "vue-router"
import { useAuthStore } from "@core/stores/auth.store"
import { ensureAuthUserLoaded } from "@core/router/building.routes"
import PageBuildingConsoChauffage from "./pages/PageBuildingConsoChauffage.vue"
import PageReglageChaufferie from "./pages/PageReglageChaufferie.vue"
import PageBuildingAnalyseTempAmbiance from "./pages/PageBuildingAnalyseTempAmbiance.vue"
import PageBuildingAlarm from "./pages/PageBuildingAlarm.vue"
import PageEnergyManagerEvolutionConso from "./pages/PageEnergyManagerEvolutionConso.vue"
import { registerEnergyManagerDashboardMessages } from "./utils/i18n"

export const buildingShellChildren = [
    {
        path: "chauffage/consommation",
        name: "PageBuildingConsoChauffage",
        component: PageBuildingConsoChauffage,
        beforeEnter: async (to, _from, next) => {
            const authStore = useAuthStore()
            await ensureAuthUserLoaded(authStore)
            if (
                authStore.hasOfferEnergyManager &&
                authStore.hasModuleExploitantChauffagiste
            ) {
                next()
            } else {
                next({
                    name: "PageBuildingMeter",
                    params: {
                        _id_building: String(to.params._id_building),
                    },
                })
            }
        },
    },
    {
        path: "chauffage/reglage-chaufferie",
        name: "PageReglageChaufferie",
        component: PageReglageChaufferie,
        beforeEnter: async (to, _from, next) => {
            const authStore = useAuthStore()
            await ensureAuthUserLoaded(authStore)
            if (
                authStore.hasOfferEnergyManager &&
                authStore.hasModuleExploitantChauffagiste
            ) {
                next()
            } else {
                next({
                    name: "PageBuildingMeter",
                    params: {
                        _id_building: String(to.params._id_building),
                    },
                })
            }
        },
    },
    {
        path: "chauffage/analyse-temp-ambiance",
        name: "PageBuildingAnalyseTempAmbiance",
        component: PageBuildingAnalyseTempAmbiance,
        beforeEnter: async (to, _from, next) => {
            const authStore = useAuthStore()
            await ensureAuthUserLoaded(authStore)
            if (
                authStore.hasOfferEnergyManager &&
                authStore.hasModuleExploitantChauffagiste
            ) {
                next()
            } else {
                next({
                    name: "PageBuildingMeter",
                    params: {
                        _id_building: String(to.params._id_building),
                    },
                })
            }
        },
    },
    {
        path: "energy-manager/evolution-conso",
        name: "PageEnergyManagerEvolutionConso",
        component: PageEnergyManagerEvolutionConso,
        beforeEnter: async (to, _from, next) => {
            registerEnergyManagerDashboardMessages()
            const authStore = useAuthStore()
            await ensureAuthUserLoaded(authStore)
            if (authStore.hasOfferEnergyManager) {
                next()
            } else {
                next({
                    name: "PageBuildingMeter",
                    params: {
                        _id_building: String(to.params._id_building),
                    },
                })
            }
        },
    },
    {
        path: "alarme",
        name: "PageBuildingAlarm",
        component: PageBuildingAlarm,
        beforeEnter: async (to, _from, next) => {
            const authStore = useAuthStore()
            await ensureAuthUserLoaded(authStore)
            if (authStore.hasOfferEnergyManager) {
                next()
            } else {
                next({
                    name: "PageBuildingMeter",
                    params: {
                        _id_building: String(to.params._id_building),
                    },
                })
            }
        },
    },
] as RouteRecordRaw[]
